/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Big_Fluffy_Fireant_AdoreInputs */

const fr_big_fluffy_fireant_adore = /** @type {(inputs: Big_Fluffy_Fireant_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer`)
};

/**

* @param {Big_Fluffy_Fireant_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const big_fluffy_fireant_adore = /** @type {((inputs?: Big_Fluffy_Fireant_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Big_Fluffy_Fireant_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_big_fluffy_fireant_adore(inputs)
});